import React from 'react';
import './RichTextDisplay.css';

interface RichTextDisplayProps {
  html: string;
  className?: string;
}

export const RichTextDisplay: React.FC<RichTextDisplayProps> = ({ html, className }) => {
  return (
    <div
      className={['rte-display', className].filter(Boolean).join(' ')}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
